import { MobileWarningModal } from '@/components/Elements/MobileWarningModal/MobileWarningModal';
import { AnalyzeRoutes } from '@/features/analyze/routes';
import { BookmarkRoutes } from '@/features/bookmark/routes';
import { SavedFilterAlertRoutes } from '@/features/saved-filter-alert';
import { SettingsRoutes } from '@/features/settings/routes';
import { SetupRoutes } from '@/features/setup/routes';
import { SubscriptionRoutes } from '@/features/subscription/routes';
import { ThemeRoutes } from '@/features/theme/routes';
import { ForceLoginState } from '@/providers/ForceLoginState';
import { Outlet } from 'react-router-dom';

export const PRIVATE_TOP_PATH = '/themes';

const PrivateApp = () => {
  return (
    <ForceLoginState type="loggedInOnly">
      <MobileWarningModal />
      <Outlet />
    </ForceLoginState>
  );
};

export const privateRoutes = [
  {
    element: <PrivateApp />,
    children: [
      { path: `${PRIVATE_TOP_PATH}/*`, element: <ThemeRoutes /> },
      { path: '/saved-filter-alerts/*', element: <SavedFilterAlertRoutes /> },
      { path: '/analyze/*', element: <AnalyzeRoutes /> },
      { path: '/setup/*', element: <SetupRoutes /> },
      { path: '/settings/*', element: <SettingsRoutes /> },
      { path: '/subscription/*', element: <SubscriptionRoutes /> },
      { path: '/bookmark/*', element: <BookmarkRoutes /> },
    ],
  },
];
